import axios from '@/utils/AxiosConfig';

export default {
  async all(sortBy, orderBy) {
    return axios.api.get(`/businesses?sortBy=${sortBy}&orderBy=${orderBy}`);
  },
  async forSector(sector, sortBy, orderBy) {
    return axios.api.get(`/businesses/sectors/${sector}?sortBy=${sortBy}&orderBy=${orderBy}`);
  },
  async forCategory(sector, category, sortBy, orderBy) {
    return axios.api.get(`/businesses/sectors/${sector}/categories/${category}?sortBy=${sortBy}&orderBy=${orderBy}`);
  },
  async business(sector, category, business) {
    return axios.api.get(`/businesses/sectors/${sector}/categories/${category}/${business}`);
  },
  similarBusinesses: async (business, limit = 5) => axios.api.get(`/businesses/${business}/related?limit=${limit}`),
  topRated: async (limit = 5) => axios.api.get(`/businesses/top-rated?limit=${limit}`),
  mostVoted: async (limit = 5) => axios.api.get(`/businesses/popular?limit=${limit}`),
  topRatedBySector: async (sector, limit = 5) => axios.api.get(`/businesses/sectors/${sector}/top-rated?limit=${limit}`),
  mostVotedBySector: async (sector, limit = 5) => axios.api.get(`/businesses/sectors/${sector}/popular?limit=${limit}`),
  topRatedByCategory: async (category, limit = 5) => axios.api.get(`/businesses/categories/${category}/top-rated?limit=${limit}`),
  mostVotedByCategory: async (category, limit = 5) => axios.api.get(`/businesses/categories/${category}/popular?limit=${limit}`),
  contributorTopRated: async (contributor, category, limit = 5) => axios.api.get(`/contributors/${contributor}/businesses/categories/${category}/top-rated?limit=${limit}&sortBy=rating`),

  toggleLike: async (payload) => axios.api.post(`/businesses/toggle-vote`, payload),
  toggleBookmark: async (payload) => axios.api.post(`/businesses/toggle-bookmark`, payload),

  reviewBusiness: async (payload) => axios.api.post(`/businesses/reviews`, payload),
  updateBusinessReview: async (reviewId, payload) => axios.api.post(`/businesses/${reviewId}`, payload),

  commentReview: async (payload) => axios.api.post(`/businesses/reviews/comments`, payload),
  updateReviewComment: async (commentId, payload) => axios.api.post(`/businesses/reviews/comments/${commentId}`, payload),

  constructBusiness: (business) => ({
      id: business.id,
      type: business.type,
      ...business.attributes,
      creator: {
        id: business.relationships.createdBy.id,
        type: business.relationships.createdBy.type,
        ...business.relationships.createdBy.attributes,
        profile: {
          id: business.relationships.createdBy.relationships.profile.id,
          type: business.relationships.createdBy.relationships.profile.type,
          ...business.relationships.createdBy.relationships.profile.attributes,
        }
      },
      category: {
        id: business.relationships.category.id,
        type: business.relationships.category.type,
        ...business.relationships.category.attributes,
      },
      sector: {
        id: business.relationships.sector.id,
        type: business.relationships.sector.type,
        ...business.relationships.sector.attributes,
      },
      region: {
        id: business.relationships.region.id,
        type: business.relationships.region.type,
        ...business.relationships.region.attributes,
      },
      city: {
        id: business.relationships.city.id,
        type: business.relationships.city.type,
        ...business.relationships.city.attributes,
      },
      reviews: business.relationships.reviews,
    }),
};
